import "./home.css";
import illustrator from "./illustration.svg";
import ImageSlider from "../../components/slider/ImageSlider";
import Supermanpic from "./slidingImages/Superman.jpg";
import rock from "./slidingImages/rock.jpg";
import Alien from "./slidingImages/alienOutpost.jpg";
import johnwick from "./slidingImages/johnWick.jpg";
import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import HomeEventSlider from "../../components/movieSlider/eventSlider";
import HomeMovieSlider from "../../components/movieSlider/movieSlider";
import MainBanner from "../movies/bannerMovieCarousel";
import MovieCarouselComponent from "../../components/NewMovieCarousel/MovieCarousel";
import EventsCarouselComponent from "../../components/Event_Carousel/Event_Carousel";

const HomePage = () => {
  const [images, setImages] = useState([Supermanpic, Alien, rock, johnwick]);
  const currentIndexRef = useRef(0);
  const imageListRef = useRef(null); // Ref for the ul element containing the images

  const [searchOption, setSearchOption] = useState(["events", "movies"]);

  useEffect(() => {
    const interval = setInterval(() => {
      currentIndexRef.current = (currentIndexRef.current + 1) % images.length;
      updateImage();
    }, 5000); // change image every 5 seconds

    return () => {
      clearInterval(interval);
    };
  }, [images]);

  const updateImage = () => {
    if (imageListRef.current) {
      const children = imageListRef.current.children;
      for (let i = 0; i < children.length; i++) {
        children[i].classList.remove("active");
      }
      children[currentIndexRef.current].classList.add("active");
    }
  };
  
  return (
    <>
      <section className="initialSection ">
        <div className="intro almost-full-width textCenter">
          <h1>Discover the Magic of Entertainment</h1>
          <p className="textCenter ">
            Are you ready for a cinematic adventure? Look no further! At
            Tickets.lk, we're your gateway to an enchanting world of movies,
            events, and unforgettable experiences.
          </p>
        </div>

        <div className="searchBar flexB almost-full-width">
          <input type="text" name="search" id="search" />
          <button className="searchBtn">Search</button>
          <select name="cars" id="cars">
            {searchOption.map((opt) => (
              <option key={opt} value={opt}>{opt}</option>
            ))}
          </select>
        </div>

        <ul ref={imageListRef} className="nonInteractable-Carousal">
          {images.map((image, index) => (
            <li key={index} className={`slide ${index === 0 ? "active" : ""}`}>
              <img src={image} alt="" />
            </li>
          ))}
        </ul>
      </section>

      <section className="homeContents">
        <section className="moviesBannerSection">
          <MainBanner />
        </section>
        <section className="movies">
          <div className="almost-full-width"><h2 className="heading_underline">Movies</h2></div>
          <MovieCarouselComponent/>
         
        </section>

        <section className="events">
        <div className="almost-full-width"><h2 className="heading_underline">Events</h2>
        <EventsCarouselComponent/>
        <Link to="/events">View More</Link>
        </div>
        </section>
      </section>
    </>
  );
};

export default HomePage;
